import React, { useMemo } from 'react';
import EventsView from './events-view';
import useURLSearchQuery from '../../../../hooks/use-url-for-search-query';
import { useApiEvents } from './use-api-events';
import { DEFAULT_LIMIT } from '../constants';
import { formatDate } from '../audit-utils';
import { EventsFilters } from '../types';

interface EventsSearch {
  [key: string]: string | string[];
  day: string;
  entity: string;
  logLevel: string;
}

const defaultSearch: EventsSearch = {
  day: formatDate(new Date()),
  entity: '',
  logLevel: '',
};

const EventsContainer: React.FC = () => {
  const [queryValues, updateURLQuery] = useURLSearchQuery<EventsSearch>(defaultSearch);

  const { day, entity, logLevel } = queryValues;

  const filters: EventsFilters = useMemo(() => ({
    day: day || undefined,
    entity: entity || undefined,
    logLevel: logLevel || undefined,
    limit: DEFAULT_LIMIT,
  }), [day, entity, logLevel]);

  const {
    events,
    isLoading,
    error,
    hasMore,
    loadMore,
  } = useApiEvents(filters);

  const handleFilterChange = (name: string, value: unknown) => {
    updateURLQuery({ [name]: String(value ?? '') });
  };

  return (
    <EventsView
      events={events}
      isLoading={isLoading}
      error={error}
      hasMore={hasMore}
      loadMore={loadMore}
      filters={queryValues}
      onFilterChange={handleFilterChange}
    />
  );
};

export default EventsContainer;
